import { render, staticRenderFns } from "./teaching.vue?vue&type=template&id=c044acd8&scoped=true&"
import script from "./teaching.vue?vue&type=script&lang=ts&"
export * from "./teaching.vue?vue&type=script&lang=ts&"
import style0 from "./teaching.vue?vue&type=style&index=0&id=c044acd8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c044acd8",
  null
  
)

export default component.exports